import { Component, OnInit } from '@angular/core';

// rxjs
import { Subject, combineLatest, interval } from "rxjs";
import { takeUntil, startWith, debounceTime } from "rxjs/operators";

import { EventService } from "../../services/event.service";
import { UserService } from "../../services/user.service";
import { OverlayService } from "../../services/overlay.service";

import { Event } from "../../models/event";
import { User } from "../../models/user";

@Component({
    selector: 'app-out-link',
    templateUrl: './app-out-link.component.html',
    styleUrls: ['./app-out-link.component.scss'],
})
export class AppOutLinkComponent implements OnInit {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * user
     *
     * @type {User}
     */
    public user: User;

    /**
     * event
     *
     * @type {Event}
     */
    public event: Event;

    public externalButton;

    constructor(
        private overlayService: OverlayService,
        public eventService: EventService,
        public userService: UserService
    ) { }

    ngOnInit() {


        let subscriptions = {};

        subscriptions['event'] = this.eventService.getCurrentEvent();

        subscriptions['user'] = this.userService.getCurrentUser();


        combineLatest(this.eventService.getCurrentEvent(), this.userService.getCurrentUser()).pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe(([event, user]) => {

            this.event = <Event>event;
            this.user = <User>user;

            this.checAppButtonRules();

            const source = interval(10000);

            source.pipe(
                startWith(10000),
                takeUntil(this.ngUnsubscribe)
            ).subscribe(() => {
                this.checAppButtonRules();
            });

        });

    }

    checAppButtonRules() {
        this.externalButton = null;
        // get active functionality for main button
        if (this.event.setting.app_setting && this.event.setting.app_setting.hasOwnProperty('external_button')) {
            // find current button functionality
            this.event.setting.app_setting.external_button.forEach((externalButton) => {
                // check requiremens
                let valid = true;

                let date = new Date();
                let utc = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));

                externalButton.required.forEach((rule) => {
                    switch (rule.type) {
                        case 'start':
                            let startDate = new Date(rule.value);
                            if (utc < startDate) {
                                valid = false;
                            }
                            break;
                        case 'end':
                            let endDate = new Date(rule.value);
                            if (utc > endDate) {
                                valid = false;
                            }
                            break;
                        case 'filled':
                            if (this.user && this.user.selected_participant && !this.user.selected_participant[rule.value]) {
                                valid = false;
                            }
                            break;
                        default:
                            if (this.user && this.user.selected_participant && this.user.selected_participant[rule.type] != rule.value) {
                                valid = false;
                            }
                            break;
                    }
                });

                if (valid && !this.externalButton) {
                    this.externalButton = externalButton;
                }
            })
        }
    }

    openLink() {
        // https://theroundrectangle.com/amasol/event/index.html
        window.open(this.externalButton.link + '?token=' + this.user.selected_participant.external_token, '_blank');
    }

    showInfo() {
        this.overlayService.showConfirmInfo(
            this.externalButton.info_header,
            this.externalButton.info_text,
            () => {

            }
        );
    }

}
